import { fetchUtils } from 'react-admin';
import Cookies from '../Utils/cookies';
import simpleDataProvider from './ra-strapi-rest';
import { transformAddresses } from '../Utils/dataTransformers';

const httpClient = (url, options: any = {}) => {
  if (!options.headers) {
    options.headers = new Headers({ Accept: 'application/json' });
  }
  const token = Cookies.getCookie('token');
  options.headers.set('Authorization', `Bearer ${token}`);

  return fetchUtils.fetchJson(url, options);
};

const baseDataProvider = simpleDataProvider(
  process.env.REACT_APP_API_URL,
  httpClient
);

const dataProvider = (type: string, resource: string, params: any) => {
  const shouldTransform =
    (resource === 'people' || resource === 'legal-people' || resource === 'franchises' || resource === 'assets') &&
    (type === 'UPDATE' || type === 'CREATE') &&
    params.data?.addresses;

  if (shouldTransform) {
    const transformedParams = {
      ...params,
      data: transformAddresses(params.data),
    };
    return baseDataProvider(type, resource, transformedParams);
  }

  return baseDataProvider(type, resource, params);
};

export default dataProvider;